import { createStoreSelector } from "../selectors";
export const selectBalance = (state) => createStoreSelector(state, 'balance')(state);
//# sourceMappingURL=balance.selectors.js.map